/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ImageGalleryCategory {
    angular.module("meevo.plugins.imageGalleryCategory", []);
}